// extracted by mini-css-extract-plugin
export default {"SignIn":"SignIn_SignIn__vrmkB","Notification":"SignIn_Notification__V-hZA","Error":"SignIn_Error__UCpzE","Form":"SignIn_Form__YORrw","Submit":"SignIn_Submit__nS50G"};